/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-22 15:54:31
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2026-03-23 15:30:26
 * @FilePath: /knit-web/src/locale/zh-CN/configuration.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  configuration: {
    title: '配置中心',
    managed: {
      label: '内置配置',
      description:
        '在内置配置中，您可以查看该工作空间下所在资源组的组内资源的基本信息。',
    },
    external: {
      label: '外部配置',
      description:
        '在外部配置中，您可以配置和管理外部的 AI 模型、数据库、云存储和消息通道。',
    },
    resourceType: '资源类型',
    resourceName: '资源名称',
    usedBy: '用于 {num} 个工作流',
    searchProvider: '搜索提供商...',
    all: '全部',
    aiModel: 'AI 模型',
    database: '数据库',
    storage: '云存储',
    message: '消息通道',
    webSearch: '网页搜索',
    configure: '配置',
    add: '新增',
    manage: '管理',
    edit: '编辑',
    delete: '删除',
    test: '测试',
    testSuccess: '连接成功',
    testFailed: '连接失败',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    addConfigTitle: '添加配置 - {name}',
    editConfigTitle: '编辑配置 - {name}',
    mysql: {
      configTitle: 'External MySQL Connection Configuration',
      name: '连接配置名称',
      namePlaceholder: '给用户标识该配置的名称',
      host: 'MySQL 服务器地址 (Host)',
      port: 'MySQL 服务端口 (Port)',
      user: '数据库用户名 (User)',
      password: '数据库用户密码 (Password)',
      database: '默认连接的数据库 (Database)',
    },
    description: '描述',
    descriptionPlaceholder: '请输入配置描述（可选）',
    configParams: '配置参数',
    noTemplate: '该提供商暂无配置模板',
    addConfig: '添加配置',
    noConfig: '暂无配置',
    status: {
      active: '正常',
      inactive: '已禁用',
      error: '错误',
    },
    createdAt: '创建于 {time}',
    connectionNormal: '连接正常',
    deleteConfirmTitle: '确定要删除此配置吗？',
    configList: '配置列表',
    version: '版本',
    resourcePricing: '资源定价',
    resourceLimits: '资源限制',
    pricingItem: '计费项',
    limitItem: '限制项',
    unit: '单位',
    value: '数值',
    limitDefinition: '限制定义',
    loading: '加载中...',
    search: '搜索',
    latency: '延迟',
    configDetail: '配置详情',
    vendor: '供应商',
    noData: '暂无数据',
    other: '其他',
    configuration: '配置',
    unconfigured: '未配置',
    email: {
      smtpServer: 'SMTP 服务器',
      smtpServerDesc: 'SMTP 服务器地址，如 smtp.example.com',
      port: '端口',
      portDesc: 'SMTP 服务端口号',
      username: '用户名',
      usernameDesc: 'SMTP 用户名/邮箱地址',
      password: '密码',
      passwordDesc: 'SMTP 密码或应用专用密码',
      from: '发件人地址',
      fromDesc: '发件人邮箱地址，如 sender@example.com',
      fromName: '发件人名称',
      fromNameDesc: '发件人显示名称（可选）',
      subject: '邮件主题',
      subjectDesc: '邮件主题，支持模板变量如 {{title}}',
      isHtml: 'HTML 格式',
      isHtmlDesc: '是否发送 HTML 格式邮件',
      useTls: '使用 TLS',
      useTlsDesc: '是否使用 TLS 加密',
    },
    // AI 模型通用配置
    aiModelConfig: {
      configTitle: '{provider} 配置',
      providerKeyTitle: '{provider} API Key 配置',
      modelKeyTitle: '{provider} 指定模型配置',
      configType: '配置类型',
      providerKey: 'API Key 统一配置',
      modelKey: '指定模型配置',
      configName: '配置名称',
      configNamePlaceholder: '给用户标识该配置的名称',
      configNameDesc: '若未填写，系统自动生成默认名称',
      apiKeyRequired: 'API Key 为必填项',
      modelName: '模型名称',
      modelNameRequired: '模型名称为必填项',
      modelType: '模型类型',
      modelTypeRequired: '模型类型为必填项',
      modelTypeLLM: 'LLM',
      modelTypeEmbedding: 'Text Embedding',
      modelTypeSTT: 'ASR',
      modelTypeModeration: 'Moderation',
      modelTypeTTS: 'TTS',
      modelTypeVideoParser: '视频理解',
      modelTypeImageGeneration: '图像生成',
      modelTypeImageUnderParser: '图像理解',
      modelTypeVideoGeneration: '视频生成',
      modelType3DGeneration: '3D 模型生成',
      modelTypeRerank: 'Rerank',
      selectModelType: '选择模型类型',
      testApiKey: '测试 API Key',
      getModelList: '获取模型列表',
      fillRequiredFields: '请先填写必填的认证字段',
      testing: '获取中...',
      testSuccess: '获取模型列表成功',
      testFailed: '获取模型列表失败',
      availableModels: '可用模型',
      matchedModels: '以下模型可添加',
      needsInfoModels: '还有 {count} 个模型需要补充信息后添加',
      addModel: '添加模型',
      modelNameCol: '模型名称',
      modelTypeCol: '模型类型',
      missingTenantOrWorkspace: '缺少租户或工作空间信息',
      selectAtLeastOneModel: '请至少选择一个模型',
      configCreateSuccess: '配置创建成功',
      configCreateFailed: '配置创建失败',
      configUpdateSuccess: '配置更新成功',
      configUpdateFailed: '配置更新失败',
      // 获取 API Key 链接
      getApiKeyFromOpenAI: '从 OpenAI 获取 API Key',
      getApiKeyFromAnthropic: '从 Anthropic 获取 API Key',
      getApiKeyFromGoogle: '从 Google AI Studio 获取 API Key',
      getApiKeyFromDeepSeek: '从 DeepSeek 获取 API Key',
    },
    missingProviderInfo: '缺少提供商信息',
  },
};
